import React, { useState, useEffect } from "react";
import { columns } from "../../internals/data/withdrawalData.js";
import { DataGrid } from "@mui/x-data-grid";
import CircularProgress from "@mui/material/CircularProgress";
import { Box, Grid } from "@mui/material";
import { getWithdrawals } from "../../actions/withdrawal.js";
import { useNavigate } from "react-router";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
	odd: {},
	even: {},
});

const WithdrawalReport = ({ token, id, isAuthenticated, setIsAuthenticated, userType }) => {
	const [rows, setRows] = useState(null);
	const navigate = useNavigate();
	const classes = useStyles();

	useEffect(() => {
		getWithdrawals(token, id, userType, (res) => {
			if (!res.error) {
				setRows(res.data);
			} else {
				if (res.message.toString().includes("Token Expired")) {
					navigate("/logout");
				}
			}
		});
	}, []);
	return (
		<>
			{rows ? (
				<DataGrid
					checkboxSelection={false}
					rows={rows}
					columns={columns}
					getRowClassName={(params) => (params.indexRelativeToCurrentPage % 2 === 0 ? classes.even : classes.odd)}
					initialState={{
						pagination: { paginationModel: { pageSize: 20 } },
					}}
					pageSizeOptions={[10, 20, 50]}
					disableColumnResize
					showToolbar
					density="compact"
					slotProps={{
						filterPanel: {
							filterFormProps: {
								logicOperatorInputProps: {
									variant: "outlined",
									size: "small",
								},
								columnInputProps: {
									variant: "outlined",
									size: "small",
									sx: { mt: "auto" },
								},
								operatorInputProps: {
									variant: "outlined",
									size: "small",
									sx: { mt: "auto" },
								},
								valueInputProps: {
									InputComponentProps: {
										variant: "outlined",
										size: "small",
									},
								},
							},
						},
					}}
				/>
			) : (
				<Grid container sx={{ justifyContent: "center", alignContent: "center", textAlign: "center" }}>
					<Box>
						<CircularProgress color="primary" size={80} thickness={5} />
					</Box>
				</Grid>
			)}
		</>
	);
};

export default WithdrawalReport;
